export type FieldError = string;

export class ValidationException {
  constructor(public readonly data: Readonly<Record<string, FieldError[]>> = {}) {}
}
